import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessengerNoMessagesmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.156 9a.844.844 0 1 0 1.688 0 .844.844 0 0 0-1.688 0Zm3.516 0a.844.844 0 1 0 1.688 0 .844.844 0 0 0-1.688 0ZM4.641 9a.844.844 0 1 0 1.687 0 .844.844 0 0 0-1.687 0Zm11.622-3.052A7.878 7.878 0 0 0 9 1.125h-.035a7.857 7.857 0 0 0-7.84 7.912 7.9 7.9 0 0 0 .844 3.514v2.672a.808.808 0 0 0 .808.808h2.674a7.9 7.9 0 0 0 3.514.844h.037a7.88 7.88 0 0 0 3.036-.603 7.815 7.815 0 0 0 2.51-1.673 7.856 7.856 0 0 0 2.327-5.563 7.844 7.844 0 0 0-.612-3.088Zm-2.656 7.7A6.505 6.505 0 0 1 9 15.539h-.03a6.563 6.563 0 0 1-3.043-.765l-.147-.079H3.305V12.22l-.08-.147a6.562 6.562 0 0 1-.764-3.043 6.499 6.499 0 0 1 1.891-4.637 6.49 6.49 0 0 1 4.62-1.932h.03a6.507 6.507 0 0 1 4.626 1.914 6.507 6.507 0 0 1 1.915 4.655 6.514 6.514 0 0 1-1.936 4.618Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgMessengerNoMessagesmin);
export { ForwardRef as ReactComponent };
